module.exports = "/_next/static/images/regulatory-compliance-mobile-form-a9b31a6754cea258f11047f4173da81c.webp";